import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import "../../App.css";
import { UserContext } from "../context/UserContext";
import Popup3 from "./Popup3";

const VoteStatus = ({ bill }) => {
  return (
    <div className="vote-status" style={{
      marginBottom: '15px',
      padding: '10px',
      backgroundColor: '#f8f9fa',
      borderRadius: '5px',
      textAlign: 'left'
    }}>
      <div style={{ marginBottom: '5px' }}>
        <strong>Current Vote:</strong> {bill?.current_vote || 'None'}
      </div>
      
      {/* No votes yet - show initial hint */}
      {!bill?.vote_count && (
        <div style={{ color: '#0d6efd' }}>
          You have 2 chances to vote on this bill. Choose carefully!
        </div>
      )}

      {/* One vote used - show last chance warning */}
      {bill?.vote_count === 1 && (
        <div style={{ color: '#dc3545' }}>
          This is your last chance to vote on this bill!
        </div>
      )}

      {/* All votes used */}
      {bill?.vote_count >= 2 && (
        <div style={{ color: '#28a745' }}>
          You have used all your votes for this bill.
        </div>
      )}
    </div>
  );
};

function Popup2({ onClose, type, isFirstTime }) {
  const { emailId, phoneNo, state, isCandidate, candidateState, setAllVoted, allVoted } = useContext(UserContext);
  const [selectedType, setSelectedType] = useState(() => {
    // Check sessionStorage first, then fallback to Federal as default
    const storedType = sessionStorage.getItem('selectedVoteType');
    if (storedType) {
      sessionStorage.removeItem('selectedVoteType'); // Clear after reading
      return storedType;
    }
    if (isCandidate && candidateState) {
      return candidateState;
    }
    return "Federal"; // Changed to default to Federal instead of type || state
  });
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [bills, setBills] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [vote, setVote] = useState("");
  const [showPopup3, setShowPopup3] = useState(false);
  const [voteCount, setVoteCount] = useState(0);
  const [requiredVotes, setRequiredVotes] = useState(0);
  const [totalBills, setTotalBills] = useState(0);
  const [votedBills, setVotedBills] = useState([]);
  const [skippedBills, setSkippedBills] = useState([]);
  const [showThankYouMessage, setShowThankYouMessage] = useState(false);
  const [showChangeVoteConfirm, setShowChangeVoteConfirm] = useState(false);
  const [allBillsVoted, setAllBillsVoted] = useState(false);
  const [updatingCandidateStatus, setUpdatingCandidateStatus] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedChamber, setSelectedChamber] = useState("Senate");
  
  useEffect(() => {
    const fetchBills = async () => {
      setIsLoading(true);
      try {
          const response = await axios.get("/api/bills-popup", {
            params: { 
              email_id: emailId, 
              selectedType,
              phoneNo,  // Add phoneNo to get voting information
              is_candidate: isCandidate,
              candidate_state: candidateState
            },
          });

        if (response.status === 200) {
          const fetchedBills = response.data;
          setBills(fetchedBills);
          setTotalBills(fetchedBills.length);
          
          // Calculate required votes (10% for regular users, 100% for candidates)
          const required = isCandidate ? fetchedBills.length : Math.ceil(fetchedBills.length * 0.1);
          setRequiredVotes(required);
          
          // Count already voted bills
          const voted = fetchedBills.filter(bill => bill.current_vote).length;
          setVoteCount(voted);
          setVotedBills(fetchedBills.filter(bill => bill.current_vote));
          
          //todo , change this candidate verification process
          // Check if all bills are voted (for candidates)

          if (allVoted) {
              setShowThankYouMessage(true);
            }
          
        } else {
          alert("Failed to fetch bills.");
        }
      } catch (error) {
        console.error("Error fetching bills:", error);
        alert("An error occurred while fetching bills.");
      } finally {
        setIsLoading(false);
      }
    };

    if (emailId) fetchBills();
    else alert("Email ID is missing.");
  }, [emailId, selectedType, isCandidate, candidateState]);

  // Set default vote to "Yes" when a new bill is loaded
  useEffect(() => {
    if (bills[currentCategoryIndex]) {
      // If there's already a vote for this bill, use that, otherwise default to "Yes"
      setVote(bills[currentCategoryIndex].current_vote || "Yes");
    }
  }, [bills, currentCategoryIndex]);

  const handleVoteSubmit = async () => {
    // Prevent multiple rapid submissions
    if (isSubmitting) {
      return;
    }

    const currentBill = bills[currentCategoryIndex];

    if (!currentBill) return;

    // Check if user has already voted twice on this bill
    if (currentBill.vote_count >= 2) {
      alert("You have already used all your votes for this bill.");
      return;
    }

    // Check if user is trying to change their vote
    if (currentBill.current_vote && currentBill.current_vote !== vote) {
      setShowChangeVoteConfirm(true);
      return;
    }

    try {
      // Set submitting flag to true to prevent multiple submissions
      setIsSubmitting(true);
      
      const response = await axios.post(
        "/api/submit-eligible-vote",
        {
          phoneNo,
          vote,
          bill: currentBill.bill_title,
          type: currentBill.type,
        }
      );

      if (response.status === 200 || response.status === 201) {
        // Update local bill data with new vote count and previous vote
        const updatedBills = [...bills];
        updatedBills[currentCategoryIndex] = {
          ...currentBill,
          current_vote: vote,
          vote_count: (currentBill.vote_count || 0) + 1
        };
        
        setBills(updatedBills);
        
        // Add to voted bills if not already there
        if (!votedBills.includes(currentBill)) {
          setVotedBills((prev) => [...prev, currentBill]);
          setVoteCount((prev) => prev + 1);
        }
        
        // Check if all bills are voted (for candidates)

          
          if (allVoted) {
            setShowThankYouMessage(true);
          }
        
        
        // Move to next bill if available
        if (currentCategoryIndex + 1 < bills.length) {
          setCurrentCategoryIndex((prev) => prev + 1);
        } else if (voteCount + 1 >= requiredVotes) {
          // If this was the last bill and we've met the threshold
          setShowThankYouMessage(true);
        }
        
        // Reset vote for next bill
        setVote("");
        setShowChangeVoteConfirm(false);
      } else {
        alert("Failed to submit vote.");
      }
    } catch (error) {
      console.error("Error submitting vote:", error);
      alert("An error occurred while submitting your vote. Please try again in a moment.");
    } finally {
      // Add a small delay before allowing another submission
      setTimeout(() => {
        setIsSubmitting(false);
      }, 1000); // 1 second cooldown
    }
  };

  const handleNextClick = () => {
    if (voteCount >= requiredVotes) setShowPopup3(true);
    else alert(`You need to vote for at least ${requiredVotes} bills.`);
  };

  const handlePreviousClick = () => {
    if (currentCategoryIndex > 0) {
      setCurrentCategoryIndex((prev) => prev - 1);
    }
  };

  const handleSkipClick = () => {
    // Candidates cannot skip bills
    if (isCandidate) {
      alert("As a candidate, you must vote on all bills. You cannot skip any.");
      return;
    }
    
    const currentBill = bills[currentCategoryIndex];
  
    if (!votedBills.includes(currentBill) && !skippedBills.includes(currentBill)) {
      setSkippedBills((prev) => [...prev, currentBill]); // Mark bill as skipped
    }
  
    if (currentCategoryIndex + 1 < bills.length) {
      setCurrentCategoryIndex((prev) => prev + 1);
    } else {
      // Restart from skipped bills
      const unvotedBills = bills.filter(
        (bill) => !votedBills.includes(bill) && skippedBills.includes(bill)
      );
  
      if (unvotedBills.length > 0) {
        setBills(unvotedBills);
        setCurrentCategoryIndex(0);
        setSkippedBills([]); // Reset skipped bills
      } else {
        alert("You have reviewed all bills. Please ensure you meet the voting threshold.");
      }
    }
  };

  const ChangeVoteConfirmation = ({ onConfirm, onCancel }) => {
    return (
      <div style={{
        marginTop: '15px',
        padding: '15px',
        backgroundColor: '#fff3cd',
        borderRadius: '5px',
        border: '1px solid #ffeeba'
      }}>
        <p style={{ 
          color: '#856404',
          marginBottom: '15px',
          fontWeight: 'bold'
        }}>
          You've already voted on this bill. Are you sure you want to change your vote?
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <button
            onClick={onConfirm}
            style={{
              padding: '8px 20px',
              backgroundColor: '#ffc107',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Yes, change my vote
          </button>
          <button
            onClick={onCancel}
            style={{
              padding: '8px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  };

  const handleShowLeaderboard = async () => {
    if (voteCount >= requiredVotes) {
      setShowPopup3(true);
    } else {
      alert(`You need to vote for at least ${requiredVotes} bills.`);
    }
  };
  
  const handleVerifyCandidate = async () => {
    try {
      setUpdatingCandidateStatus(true);
      
      // First, verify the candidate
      const verifyResponse = await axios.post("/api/verify-candidate", {
        emailId,
        selectedChamber
      });
      
      if (verifyResponse.status === 200) {
        // Then, update firsttime value to 0
        try {
          const firstTimeResponse = await axios.patch("/api/update-firsttime", {
            email_id: emailId
          });
          
          if (firstTimeResponse.status === 200) {
            console.log("First time flag updated successfully");
          } else {
            console.warn("Failed to update first time flag");
          }
        } catch (firstTimeError) {
          console.error("Error updating first time flag:", firstTimeError);
        }
        
        setAllVoted(true);
        alert("Congratulations! You have been verified as a candidate.");
        // Redirect to home page instead of showing Popup3
        window.location.href = "/main";
      } else {
        alert("Failed to verify candidate status. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying candidate:", error);
      alert("An error occurred while verifying your candidate status.");
    } finally {
      setUpdatingCandidateStatus(false);
    }
  };

  if (showPopup3) {
    return <Popup3 onClose={onClose} selectedType={selectedType} userState={state} phoneNo={phoneNo} />;
  }

  return (
    <div
      className="popup-section"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
      }}
    >
      <div
        className="popup-container"
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "20px",
          width: "90%",
          maxWidth: "800px",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
          position: "relative",
        }}
      >
        {isLoading ? (
          <p>Loading...</p>
        ) : showThankYouMessage ? ( // Show Thank You message only when all bills are voted
          <div style={{ textAlign: "center", fontSize: "24px", padding: "20px" }}>
            🎉 Thank you for voting on all bills! 🎉
            <div style={{ 
              marginTop: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            }}>
              {isCandidate ? (
                allVoted ? (
                  <div style={{ 
                    padding: "15px",
                    backgroundColor: "#d4edda",
                    border: "1px solid #c3e6cb",
                    borderRadius: "5px",
                    color: "#155724",
                    marginTop: "10px"
                  }}>
                    You have already been verified as a candidate
                  </div>
                ) : (
                  <>
                    <div style={{ 
                      marginBottom: "20px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center"
                    }}>
                      <div style={{ fontWeight: "bold", marginBottom: "10px" }}>Select your chamber:</div>
                      <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <input
                            type="radio"
                            name="chamber"
                            value="Senate"
                            checked={selectedChamber === "Senate"}
                            onChange={(e) => setSelectedChamber(e.target.value)}
                            style={{ marginRight: "8px" }}
                          />
                          Senate
                        </label>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <input
                            type="radio"
                            name="chamber"
                            value="House of Representatives"
                            checked={selectedChamber === "House of Representatives"}
                            onChange={(e) => setSelectedChamber(e.target.value)}
                            style={{ marginRight: "8px" }}
                          />
                          House of Representatives
                        </label>
                      </div>
                    </div>
                    <div>
                      <button
                        style={{
                          padding: "10px 20px",
                          backgroundColor: "#dc3545",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          cursor: selectedChamber ? "pointer" : "not-allowed",
                          opacity: updatingCandidateStatus || !selectedChamber ? 0.7 : 1,
                          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                          transition: "all 0.3s ease",
                          transform: "translateY(0)",
                          fontWeight: "bold",
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          marginBottom: "5px",
                          width: "fit-content"
                        }}
                        onMouseEnter={(e) => {
                          if (selectedChamber && !updatingCandidateStatus) {
                            e.currentTarget.style.backgroundColor = "#c82333";
                            e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.3)";
                            e.currentTarget.style.transform = "translateY(-2px)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedChamber && !updatingCandidateStatus) {
                            e.currentTarget.style.backgroundColor = "#dc3545";
                            e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                            e.currentTarget.style.transform = "translateY(0)";
                          }
                        }}
                        onClick={handleVerifyCandidate}
                        disabled={updatingCandidateStatus || !selectedChamber}
                      >
                        {updatingCandidateStatus ? (
                          <>
                            <span style={{ display: "inline-block", animation: "spin 1s linear infinite" }}>↻</span>
                            Verifying...
                          </>
                        ) : (
                          <>
                            <span>✓</span>
                            Verify as Candidate
                          </>
                        )}
                      </button>
                      <div style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "5px",
                        fontStyle: "italic",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px"
                      }}>
                        <span style={{ fontSize: "14px" }}>👆</span>
                        Click here to complete your candidate verification
                      </div>
                    </div>
                  </>
                )
              ) : (
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%"
                }}>
                  <button
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "#dc3545",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      transition: "all 0.3s ease",
                      transform: "translateY(0)",
                      fontWeight: "bold",
                      fontSize: "16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      marginBottom: "5px",
                      width: "fit-content"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#c82333";
                      e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.3)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#dc3545";
                      e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                    onClick={handleNextClick}
                  >
                    <span>🏆</span>
                    Click here to show the leaderboard
                  </button>
                  <div style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "5px",
                    fontStyle: "italic",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px"
                  }}>
                    <span style={{ fontSize: "14px" }}>👆</span>
                    Click to view how your votes match with politicians
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <>
            {/* Display progress for candidates */}
            {isCandidate && (
              <div style={{ 
                textAlign: "center", 
                marginBottom: "15px", 
                padding: "10px", 
                backgroundColor: "#f8f9fa", 
                borderRadius: "5px" 
              }}>
                <p style={{ 
                  fontWeight: "bold", 
                  color: voteCount === totalBills ? "#28a745" : "#dc3545" 
                }}>
                  Progress: {voteCount}/{totalBills} bills voted
                </p>
                <div style={{ 
                  width: "100%", 
                  height: "10px", 
                  backgroundColor: "#e9ecef", 
                  borderRadius: "5px", 
                  marginTop: "5px" 
                }}>
                  <div style={{ 
                    width: `${(voteCount / totalBills) * 100}%`, 
                    height: "100%", 
                    backgroundColor: "#28a745", 
                    borderRadius: "5px", 
                    transition: "width 0.3s ease" 
                  }}></div>
                </div>
              </div>
            )}
            
            <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
              {bills[currentCategoryIndex]?.category_name}
            </h3>
            <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
              {bills[currentCategoryIndex]?.bill_title || "No Bill Available"}
            </h3>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  border: "1px solid #ccc",
                  width: "45%",
                  height: "150px",
                  textAlign: "center",
                  padding: "10px",
                  overflowY: "auto",
                }}
              >
                <strong>Pros:</strong>
                {bills[currentCategoryIndex]?.pros ? (
                  <ul style={{ paddingLeft: "20px" }}>
                    {bills[currentCategoryIndex]?.pros
                      .split(/(?:-\s*|\d+\.\s*)/) // Split by "-" or "1. "
                      .filter((item) => item.trim() !== "") // Remove empty items
                      .map((item, index) => (
                        <li key={index} dangerouslySetInnerHTML={{ __html: item.trim().replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") }} />
                      ))}
                  </ul>
              ) : (
                <p>No Pros Available</p>
              )}
              </div>
              <div
                style={{
                  border: "1px solid #ccc",
                  width: "45%",
                  height: "150px",
                  padding: "10px",
                  overflowY: "auto",
                  textAlign: "center",
                }}
              >
                <strong>Cons:</strong>
                {bills[currentCategoryIndex]?.cons ? (
                  <ul style={{ paddingLeft: "20px" }}>
                    {bills[currentCategoryIndex]?.cons
                      .split(/(?:-\s*|\d+\.\s*)/) // Split by "-" or "1. "
                      .filter((item) => item.trim() !== "") // Remove empty items
                      .map((item, index) => (
                        <li key={index} dangerouslySetInnerHTML={{ __html: item.trim().replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") }} />
                      ))}
                  </ul>
              ) : (
                <p>No Pros Available</p>
              )}
              </div>
            </div>
            <div style={{ textAlign: "center"}}>
              <VoteStatus bill={bills[currentCategoryIndex]} />
              
              {bills[currentCategoryIndex]?.vote_count === 1 && !showChangeVoteConfirm && (
                <ChangeVoteConfirmation 
                  onConfirm={() => {
                    setShowChangeVoteConfirm(true);
                  }}
                  onCancel={() => {
                    // Move to next bill
                    setCurrentCategoryIndex(prev => prev + 1 < bills.length ? prev + 1 : prev);
                  }}
                />
              )}

              {((!bills[currentCategoryIndex]?.vote_count || bills[currentCategoryIndex]?.vote_count < 2) && 
                (showChangeVoteConfirm || !bills[currentCategoryIndex]?.vote_count)) && (
                <>
                  <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                    <div style={{ fontWeight: "bold", marginBottom: "10px" }}>Your Vote:</div>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                        <input
                          type="radio"
                          name="vote"
                          value="Yes"
                          checked={vote === "Yes"}
                          onChange={() => setVote("Yes")}
                          style={{ marginRight: "8px" }}
                        />
                        Yes
                      </label>
                      <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                        <input
                          type="radio"
                          name="vote"
                          value="No"
                          checked={vote === "No"}
                          onChange={() => setVote("No")}
                          style={{ marginRight: "8px" }}
                        />
                        No
                      </label>
                    </div>
                  </div>

                  <button
                    onClick={handleVoteSubmit}
                    style={{
                      padding: '8px 20px',
                      backgroundColor: '#007bff',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      marginBottom: '10px'
                    }}
                  >
                    Submit
                  </button>
                </>
              )}
              <p>Votes submitted: {voteCount}/{totalBills}</p>
              {isCandidate && (
                <p style={{ color: '#dc3545', fontWeight: 'bold' }}>
                  As a candidate, you must vote on all bills to complete registration.
                </p>
              )}
            </div>
            <div style={{ 
              display: 'flex', 
              gap: '10px',
              marginTop: '20px'
            }}>
              {/* Only show Exit button for non-candidates */}
              {!isCandidate && (
                <button
                  style={{
                    padding: '8px 20px',
                    backgroundColor: '#dc3545',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    flex: '1'
                  }}
                  onClick={onClose}
                >
                  Exit
                </button>
              )}
              
              {/* For all candidates (including first-time), show exit button with auto-save hint */}
              {isCandidate && (
                <button
                  style={{
                    padding: '8px 20px',
                    backgroundColor: '#dc3545',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    flex: '1',
                    position: 'relative'
                  }}
                  onClick={() => {
                    alert("Your voting progress is saved. You can continue voting when you return. ❗ If you are a candidate, please go to the drop down menu and click on 'category preference / candidate verification' page to finish up verifying your candidature.");
                    onClose();
                    // Redirect to root path after closing
                    window.location.href = "/main";
                  }}
                >
                  Save and Exit
                  <div style={{
                    position: 'absolute',
                    bottom: '-20px',
                    left: '0',
                    width: '100%',
                    fontSize: '10px',
                    color: '#6c757d',
                    fontStyle: 'italic'
                  }}>
                    Progress auto-saved
                  </div>
                </button>
              )}
              
              <button
                style={{
                  padding: '8px 20px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  flex: '1'
                }}
                onClick={handlePreviousClick}
              >
                Previous
              </button>
              <button
                style={{
                  padding: '8px 20px',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  flex: '1'
                }}
                onClick={handleSkipClick}
              >
                Next
              </button>
              {/* Only show leaderboard button for non-candidates */}
              {!isCandidate && (
                <button
                  style={{
                    padding: '8px 20px',
                    backgroundColor: '#17a2b8',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    flex: '1'
                  }}
                  onClick={handleShowLeaderboard}
                >
                  Show the leaderboard
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Popup2;
